import React from 'react';
import { Modal, OverlaySpinner, OverlaySpinnerType } from '@adjust/dashboard-components';

import { Error } from '@common/Error/Error';
import { ChangePricingPlanTermsContainer } from './ChangePricingPlanTerms/ChangePricingPlanTerms.container';
import { ChangePricingPlanFormContainer } from './ChangePricingPlanForm/ChangePricingPlanForm.container';

import './ChangePricingPlan.scss';

export interface ChangePricingPlanProps {
  isShown: boolean;
  isErrorOccurred: boolean;
  areTermsShown: boolean;
  isLoading: boolean;
}

export const ChangePricingPlan = ({ isShown, areTermsShown, isErrorOccurred, isLoading }: ChangePricingPlanProps) => (
  <Modal isOpen={isShown} extraClasses="change-pricing-plan">
    <OverlaySpinner isLoading={isLoading} backgroundType={OverlaySpinnerType.Pale} />

    {isErrorOccurred && <Error error={t('error.an-error-occurred.try-again-later')} />}

    {areTermsShown ? <ChangePricingPlanTermsContainer /> : <ChangePricingPlanFormContainer />}
  </Modal>
);
